<template>
  <div>
    <div class="logo-wrapper d-flex align-items-center justify-content-between" :class="{ 'is-inverted': isFleetPartnerOnly }">
      <Logo :is-fleet-partner-only="isFleetPartnerOnly" />

      <IconButton @click="toggleSidebar" title="Toggle Sidebar" :invert-color="isFleetPartnerOnly">
        <svg
          width="24"
          height="24"
          viewBox="7 5 10 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M14.5 17L9.5 12L14.5 7" />
        </svg>
      </IconButton>
    </div>
    <!-- <div class="logo-icon-wrapper">
      <router-link to="/">
        <img
          class="img-fluid"
          src="../../assets/images/logo/logo-icon.png"
          alt=""
      /></router-link>
    </div> -->
    <Nav />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import Logo from './logo.vue';
  import Nav from './nav.vue';
  import IconButton from '@/components/common/IconButton.vue';
  import { usePartnerType } from '@/composables/common';

  export default {
    name: 'Sidebar',
    components: {
      Logo,
      Nav,
      IconButton,
    },
    computed: {
      ...mapState({
        menuItems: (state) => state.menu.data,
        activeoverlay: (state) => state.menu.activeoverlay,
        isToggleSidebar: (state) => state.menu.togglesidebar,
      }),
    },
    setup() {
      const { isFleetPartnerOnly } = usePartnerType();
      return { isFleetPartnerOnly };
    },
    methods: {
      toggle_sidebar() {
        this.$store.dispatch('menu/opensidebar');
        this.$store.state.menu.activeoverlay = false;
      },
      toggleSidebar() {
        this.$store.dispatch('menu/opensidebar');
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "@/assets/scss/utils/variables";

.is-inverted {
  background-color: $primary-color;
  box-shadow: -9px 0 20px rgba(89, 102, 122, 0.3) !important;
}
</style>
